import AppActions from 'bukku/redux/App/actions';
import dayjs from 'dayjs';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AppModalType } from '../../../../../enums/AppModalType';
import { CookieKey } from '../../../../../enums/CookieKey';
import { MomentFormatEnums } from '../../../../../enums/MomentEnums';
import { CookiesHelper } from '../../../../../helpers/CookiesHelper';
import { IDLE_TIMEOUT_DURATION, IDLE_TIMEOUT_TIME_UNIT, isDebugIdleModal } from '../../constants';
import { useIdleApiCallListener } from './useIdleApiCallListener';
import { useIdlePollingTimer } from './useIdlePollingTimer';
import { useResetCookieListener } from './useResetCookieListener';

const {
    closeAppModal,
} = AppActions;

export const useIdleObserver = () => {
    const dispatch = useDispatch();

    const rememberMe = CookiesHelper.getCookie(CookieKey.remember_me) === 'true';
    const cookieExpiryDay = rememberMe ? 7 : 1;
    const setCookieIdleTime = dayjs().add(IDLE_TIMEOUT_DURATION, IDLE_TIMEOUT_TIME_UNIT);

    const resetCookieAndCloseModal = useCallback(() => {
        if (isDebugIdleModal) {
            console.log('aaa debug Inactive Modal V2 - resetCookieAndCloseModal', {
                idleTime: setCookieIdleTime,
                rememberMe,
                cookieExpiryDay,
            });
        }
        CookiesHelper.setCookies(
            CookieKey.session_idle,
            setCookieIdleTime.format(MomentFormatEnums.date_time),
            cookieExpiryDay,
        );
        dispatch(closeAppModal(AppModalType.IDLE_MODAL));
    }, [dispatch, setCookieIdleTime, rememberMe, cookieExpiryDay]);

    // Listener 1: polling with time interval of 1 second to check cookie session_idle_expiry
    // will continue polling even if idle (no clearInterval) - to detect if reauthenticated (cross-tab)
    useIdlePollingTimer(resetCookieAndCloseModal);

    // Listener 2: api calls will trigger checking of cookie session_idle_expiry
    // Rationale: there might be api calls that are happening while polling is happening halfway
    // eg: 60 secs polling interval, api call happens at 30 secs, polling will only check at 60 secs
    useIdleApiCallListener(resetCookieAndCloseModal);

    // Reset Cookie and Close Modal Listener - after reauthenticate / session expiry relogin success
    useResetCookieListener(resetCookieAndCloseModal);

    // return timer;
};
